import React, {Component} from 'react';
import Icon from '../../Icon';
import messages from '../../../../res/translations/messages';
import TooltipContainer from '../../TooltipContainer';

class CloneItemButton extends Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.confirmClicked = this.confirmClicked.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    confirmClicked() {
        return this.setState({modal: false}, () => this.props.onClone());
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {onClone} = this.props;

        return (
            <TooltipContainer component="button" tooltip={messages.surveys.tooltips.cloneItem}
                className="btn btn-link border-left" type="button" onClick={onClone}>
                <Icon icon="duplicate" />
            </TooltipContainer>
        );
    }
}

export default CloneItemButton;
